interface Props extends Omit<React.ComponentProps<"img">, "src"> {
  src: string | null | undefined;
  fallback?: string | null;
}

// Shows `src`, switching to `fallback` if it fails to load. A just-uploaded image's
// display copy can lag behind the upload, so pages pass the display copy as `src`
// and the original as `fallback`.
const FallbackImage: React.FC<Props> = ({ src, fallback, alt = "", onError, ...props }) => (
  <img
    src={src ?? fallback ?? undefined}
    alt={alt}
    onError={(e) => {
      // `src` is resolved to an absolute URL, so it never equals a relative fallback.
      if (fallback && e.currentTarget.getAttribute("src") !== fallback) {
        e.currentTarget.src = fallback;
      }
      onError?.(e);
    }}
    {...props}
  />
);

export default FallbackImage;
